import React from "react"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import FeaturesList, { ListItem } from "components/ui/FeaturesList"
import Heading from "components/ui/Heading"

function PresetForPrivateCloudSection() {
  const { getAsset } = usePageAssets()
  const deployAndUpgrades = getAsset("mpc-deploy-and-upgrades-svg")
  const platformManagement = getAsset("mpc-platform-management-svg")
  const elasticScalability = getAsset("mpc-elastic-scalability-svg")
  const expertSupport = getAsset("mpc-expert-support-svg")
  return (
    <Container section>
      <Heading
        label="Preset for Private Cloud"
        title="Build and share dashboards securely. We take care of the rest."
        subtitle={
          <>
            All the benefits of Preset SaaS are now available inside your
            private cloud.
          </>
        }
        decoration="border"
      />
      <FeaturesList className="mt-10">
        <ListItem
          image={deployAndUpgrades}
          size="large"
          title="Deploy & Upgrades"
          center
        />
        <ListItem
          image={platformManagement}
          size="large"
          title="Platform Management"
          center
        />
        <ListItem
          image={elasticScalability}
          size="large"
          title="Elastic Scalability"
          center
        />
        <ListItem
          image={expertSupport}
          size="large"
          title="Expert Support"
          center
        />
      </FeaturesList>
    </Container>
  )
}

export default PresetForPrivateCloudSection
